/**
 * Creates a singleton instance of the AjaxHandler class for use throughout the project.
 * 
 * This file imports the AjaxHandler class, initializes it with the AJAX URL and nonce
 * provided by the localized `props` object from WordPress, and exports the instance.
 * 
 * By creating a singleton instance, you can easily use the same AJAX handler across 
 * different parts of your application, ensuring consistency and reducing duplication.
 * 
 * Example Usage:
 * - Import and use this instance in your scripts to make AJAX requests:
 *   ```javascript
 *   import ajaxHandlerInstance from './ajaxHandler';
 *   
 *   ajaxHandlerInstance.makeRequest(
 *       'my_action',
 *       { key: 'value' },
 *       (response) => { console.log('Success:', response); },
 *       (error) => { console.error('Error:', error); }
 *   );
 *   ```
 * 
 * @file Initializes and exports a singleton instance of AjaxHandler.
 */

import AjaxHandler from './ajaxHandler';

const ajaxHandlerInstance = new AjaxHandler(props.ajaxurl, props.nonce);

export default ajaxHandlerInstance;